/*
 * @Author: wangpeng wangpeng@bailongma-inc.com
 * @Date: 2024-10-10 18:10:05
 * @LastEditors: wangpeng wangpeng@bailongma-inc.com
 * @LastEditTime: 2024-10-11 08:55:18
 * @FilePath: /pegasus-web-vehicle/src/utils/useUploadCommon.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getCurrentInstance } from 'vue'
import { MessageBox } from '@qs/ui'


export const useEchoUploadFileData = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$root.getEchoUploadFileData
}
export const useUploadCommonFileData = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$root.getUoloadCommonFileData
}
export const useGetUrl = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$root.getURL
}

/**
 *  模拟一个js弹窗处理内容
 * @param    {Object} options  配置参数
 * @return   {Object}
 * */
export const customMessageBox = ({
  title = '消息',
  showCancelButton = true,
  confirmButtonText = '确定',
  cancelButtonText = '取消',
  content, // 弹窗内容 需要时一个vnode
  onConfirm,
  onCancel,
  type,
  iconClass,
}) => {
  MessageBox({
    title,
    type,
    iconClass,
    showCancelButton,
    confirmButtonText,
    cancelButtonText,
    message: content,
    beforeClose: (action, instance, done) => {
      if (action === 'confirm') {
        return onConfirm && onConfirm(instance, done)
      }
      if (action === 'cancel') {
        return onCancel && onCancel(instance, done)
      }
      done()
    },
  })
}

